







































import {Component, Vue, Watch} from 'vue-property-decorator';
import CompanyMixin from '@/mixins/CompanyMixin';
import CashflowTable from '@/components/CashflowTable.vue';

@Component({components: {CashflowTable}})
export default class CardCashflow extends CompanyMixin {
}
